import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/transactions-history-page.json'

const t = getTranslationFromJson([content])

export const useProviderName = (provider: string) => {
  const providersRec: Record<string, string> = {
    ach: t('provider_label_ach'),
    skrill: t('provider_label_skrill'),
    skrill_ach: t('provider_label_ach'),
    skrillach: t('provider_label_ach'),
    prizeout: t('provider_label_prizeout'),
    PayQuicker: t('provider_label_payquicker'),
    nuvei_mazooma_ach: t('provider_label_nuvei_mazooma_ach'),
    masspay_ach: t('provider_label_ach'),
    payper: t('provider_label_payper'),
    standard_ach: t('provider_label_standard_ach'),
    trustly: t('provider_label_trustly'),
    airwallex_ach: t('provider_label_ach'),
  }

  if (provider && provider in providersRec) {
    return providersRec[provider]
  }

  return ''
}
